/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type signup_viewer$ref: FragmentReference;
declare export opaque type signup_viewer$fragmentType: signup_viewer$ref;
export type signup_viewer = {|
  +actualPersonId: ?string,
  +downForMaintenance: ?boolean,
  +$refType: signup_viewer$ref,
|};
export type signup_viewer$data = signup_viewer;
export type signup_viewer$key = {
  +$data?: signup_viewer$data,
  +$fragmentRefs: signup_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "signup_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downForMaintenance",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '3104530ab4abc48f4cd52856b3827a78';

module.exports = node;
